import React from 'react'

import { ProductGrid, GridGap, Size } from '@pb/components'

import { handleTrackShowNibModal } from 'features/favourites/tracking'
import { FavouritesProductGridProps } from 'features/favourites/types'

const FavouritesProductGrid: React.FC<FavouritesProductGridProps> = ({
  className,
  productTileClassName,
  products,
  nibNsLabels,
  isSetNotifyIfBackLoading,
  isSetNotifyIfBackSuccessful,
  userData,
  shouldUseAkamai,
  shouldShowSkeleton,
  onClickSigninNotifyIfBack,
  setIsSetNotifyIfBackSuccessful,
  setIsShowNotifyIfBackModal,
  onSubmitNotifyIfBack,
}: FavouritesProductGridProps) => {
  return (
    <ProductGrid
      shouldUseAkamai={shouldUseAkamai}
      shouldShowSkeleton={shouldShowSkeleton}
      products={products}
      productTileClassName={productTileClassName}
      className={className}
      showOutOfStockImageCross={process.env.IS_OUT_OF_STOCK_IMAGE_CROSS_ENABLED === 'enabled'}
      showRedPriceFirst={process.env.IS_FAVOURITES_RED_PRICE_DISPLAYED_FIRST_ENABLED === 'enabled'}
      showBoldPrice={process.env.IS_FAVOURITES_BOLD_PRICE_ENABLED === 'enabled'}
      removeButtonPosition={
        process.env.IS_REMOVE_BUTTON_TOP_POSITION_ENABLED === 'enabled' ? 'top' : 'bottom'
      }
      isMarkerInMarquee={process.env.IS_MARKER_IN_MARQUEE_ENABLED === 'enabled'}
      onNibModalShow={handleTrackShowNibModal}
      isProductTileDetailsCentreAligned={
        process.env.IS_PRODUCT_TILE_DETAILS_CENTRE_ALIGNED === 'enabled'
      }
      isImageHeightAutoAdjustmentEnabled={
        process.env.IS_IMAGE_HEIGHT_AUTO_ADJUSTMENT_ENABLED === 'enabled'
      }
      productColorTextSize={process.env.PRODUCT_COLOR_TEXT_SIZE === 'large' ? 'large' : 'small'}
      removeIconName={
        process.env.REMOVE_BUTTON_ICON_NAME === 'trashCan'
          ? 'trashCan'
          : process.env.REMOVE_BUTTON_ICON_NAME === 'cross'
          ? 'cross'
          : 'close'
      }
      productPromotionMarkerPlacement={
        process.env.PRODUCT_PROMOTION_MARKER_PLACEMENT === 'image'
          ? 'image'
          : process.env.PRODUCT_PROMOTION_MARKER_PLACEMENT === 'details'
          ? 'details'
          : 'none'
      }
      dropdownIcon={process.env.DROPDOWN_ICON === 'triangle' ? 'triangle' : 'chevron'}
      isDropDownHoverEnabled={process.env.SIZE_PICKER_DROPDOWN_HOVER_ENABLED === 'enabled'}
      gridGap={process.env.GRID_GAP as GridGap | undefined}
      removeIconSize={process.env.REMOVE_BUTTON_ICON_SIZE as Size | undefined}
      productTitleTopSpacing={
        process.env.PRODUCT_TITLE_TOP_SPACING === 'noSpacing'
          ? 'noSpacing'
          : process.env.PRODUCT_TITLE_TOP_SPACING === 'medium'
          ? 'medium'
          : process.env.PRODUCT_TITLE_TOP_SPACING === 'large'
          ? 'large'
          : process.env.PRODUCT_TITLE_TOP_SPACING === 'xsmall'
          ? 'xsmall'
          : 'small'
      }
      notifyIfBack={
        process.env.NOTIFY_IF_BACK === 'pb'
          ? 'pb'
          : process.env.NOTIFY_IF_BACK === 'hm'
          ? 'hm'
          : 'none'
      }
      notifyIfBackIcon={process.env.NOTIFY_IF_BACK_ICON as 'bell' | 'email'}
      nibSpacing={process.env.NIB_SPACING as 'xxs' | 'xs' | 's' | 'l'}
      nibTextAlignment={process.env.NIB_TEXT_ALIGNMENT as 'center' | 'right' | 'left'}
      nibApiUrl={process.env.NIB_API_URL}
      nibHeadingAlignment={process.env.NIB_HEADING_ALIGNMENT as 'center' | 'left' | 'right'}
      nibModalCloseIconSize={
        process.env.NIB_MODAL_CLOSE_ICON_SIZE as 'normal' | 'small' | 'xsmall' | 'large' | 'xlarge'
      }
      nibModalCloseIconStyle={process.env.NIB_MODAL_CLOSE_ICON_STYLE as 'defined' | 'default'}
      nibButtonSize={process.env.NIB_BUTTON_SIZE as 'small' | 'medium' | 'large'}
      nibIconSize={process.env.NIB_ICON_SIZE as 'xsmall' | 'small' | 'normal' | 'large' | 'xlarge'}
      nibModalTitleSize={
        process.env.NIB_MODAL_TITLE_SIZE as 'xsmall' | 'small' | 'normal' | 'large' | 'xlarge'
      }
      nibNsLabels={nibNsLabels}
      isSetNotifyIfBackLoading={isSetNotifyIfBackLoading}
      isSetNotifyIfBackSuccessful={isSetNotifyIfBackSuccessful}
      userData={userData}
      onClickSigninNotifyIfBack={onClickSigninNotifyIfBack}
      setIsSetNotifyIfBackSuccessful={setIsSetNotifyIfBackSuccessful}
      setIsShowNotifyIfBackModal={setIsShowNotifyIfBackModal}
      onSubmitNotifyIfBack={onSubmitNotifyIfBack}
      nibPbSms={process.env.IS_NIB_PB_SMS_ENABLED === 'enabled'}
      isNibSimilarItemsEnabled={process.env.IS_NIB_SIMILAR_ITEMS_ENABLED === 'enabled'}
      nibModalType={
        process.env.NIB_MODAL_TYPE as 'stickyLeft' | 'middle' | 'stickyRight' | 'fullScreen'
      }
    />
  )
}

export default FavouritesProductGrid
